export const config = {
  title: "PristineFlow Detailing",
  meta: {
    description:
      "PristineFlow Detailing offers professional mobile auto detailing services in Ottawa, Ontario. Specializing in interior and exterior detailing, paint correction, ceramic coating, and more.",
    keywords: [
      "Auto Detailing Ottawa",
      "Mobile Car Detailing",
      "Interior Detailing",
      "Exterior Detailing",
      "Paint Correction",
      "Ceramic Coating",
      "PristineFlow Detailing"
    ],
    author: "PristineFlow Detailing",
    canonicalUrl: "https://www.pristineflowdetailing.com/",
  },
  sections: {
    header: {
      businessName: "PristineFlow Detailing",
    },
    sectionB: {
      heroTitle: "PristineFlow Detailing",
      heroSubtitle: "Professional Mobile Auto Detailing in Ottawa, ON",
      learnAboutText: "Explore Our Services",
      phoneNumber: "6132991025",
      phoneLabel: "(613) 299-1025",
      heroBackgroundImage:
      "https://media.istockphoto.com/id/1272577182/photo/car-detailing.jpg?s=612x612&w=0&k=20&c=AmH7v05Y2Yt5rf1yTiCRYrglU9-cbIwiQgAgrq3ljnY=",
      cardData: [
        {
          title: "Interior Detailing",
          description:
            "Comprehensive interior cleaning to restore your vehicle's cabin to like-new condition.",
        },
        {
          title: "Exterior Detailing",
          description:
            "Thorough exterior wash and polish to enhance your vehicle's appearance.",
        },
        {
          title: "Ceramic Coating",
          description:
            "Advanced ceramic coating application for long-lasting paint protection.",
        },
      ],
      description:
        "At PristineFlow Detailing, we provide top-tier mobile auto detailing services in Ottawa, ON. Our team is dedicated to delivering exceptional results, ensuring your vehicle looks and feels brand new.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Discover our range of professional auto detailing services tailored to meet your vehicle's needs.",
      cards: [
        {
          title: "Interior Detailing",
          description:
            "Deep cleaning of seats, carpets, and all interior surfaces for a fresh cabin feel.",
            imageSrc: "https://media.istockphoto.com/id/1288964234/photo/car-detailing-service-deep-interior-cleaning.jpg?s=612x612&w=0&k=20&c=O1jFEKtCipreEAIOhEkIwYxkq0OBd8rMYe8bOFPngtc=",
            imageAlt: "Interior Detailing",
        },
        {
          title: "Exterior Detailing",
          description:
            "Comprehensive exterior cleaning, including wash, wax, and polish.",
            imageSrc: "https://media.istockphoto.com/id/1194687583/photo/worker-examining-vehicle-body-for-scratches.jpg?s=612x612&w=0&k=20&c=tYB4Bgir9Y4eO2x6XazRXnrSnBHZB7t0BOU0j2tYPZ8=",
            imageAlt: "Exterior Detailing",
        },
        {
          title: "Ceramic Coating",
          description:
            "Application of ceramic coating to protect your vehicle's paint and enhance shine.",
            imageSrc: "https://media.istockphoto.com/id/1273682054/photo/car-service-worker-applying-nano-coating-on-a-car-detail.jpg?s=612x612&w=0&k=20&c=w2YoGPnv24lcITfiH7jnTYLAj9xCXUrlbHn33lxcd2U=",
            imageAlt: "Ceramic Coating",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Paint Correction",
        "Engine Bay Detailing",
        "Headlight Restoration",
        "Odor Removal",
        "Pet Hair Removal",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://static.wixstatic.com/media/5b2717_dc3421dd94a148539ad351ec926da6a6~mv2.png/v1/crop/x_0,y_1791,w_3596,h_3921/fill/w_416,h_432,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_1336_heic.png",
        alt: "PristineFlow Detailing Team",
      },
      aboutText: [
        "PristineFlow Detailing is a premier mobile auto detailing service based in Ottawa, ON. Our mission is to provide exceptional detailing services that exceed our clients' expectations.",
        "With a passion for automotive care, our experienced team uses high-quality products and techniques to ensure your vehicle receives the best treatment possible.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "PristineFlow Detailing Logo",
      businessName: "PristineFlow Detailing",
      contact: {
        phone: "6132991025",
        phoneLabel: "(613) 299-1025",
        email: "pristineflowdetails@gmail.com",
        website: "https://www.pristineflowdetailing.com/",
        address: "Ottawa, ON, Canada",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/pristineflowdetailing",
        instagram: "https://www.instagram.com/pristineflowdetailing",
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: "https://www.tiktok.com/@pristineflow.detailing?is_from_webapp=1&sender_device=pc"
      },
    },
    sectionF: {
      address: "Ottawa, ON, Canada",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2795.927711111111!2d-75.697111111111!3d45.421529999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cce05b111111111%3A0x1111111111111111!2sOttawa%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sca!4v1614123456789!5m2!1sen!2sca",
    },
  },
};

export default config;
